import React from 'react';
import TextInput from '../../form/TextInput';
import Select from '../../form/Select';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import {OptionFormatter} from "../../../utils/formatters";
import TextArea from "../../form/TextArea";
import Items from "./StockTransfer/Items";
import Button from "../../form/Button";
import {postData} from "../../../utils/request";

class stocktransferForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-sm-4 col-md-push-8">
                        <TextInput
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                        />
                    </div>
                    <div className="col-sm-4 col-md-pull-4">
                        <TextInput
                            {...this.props.getFieldProps("StockOperationState")}
                            disabled="disabled"
                            name="StockOperationState"
                            value={this.props.values.StockOperationState}
                            formatter={OptionFormatter}
                            label="Státusz"/>
                    </div>
                    <div className="col-sm-4 col-md-pull-4">
                        <label className="control-label">Elszámolás dátuma</label>
                        <div className="input-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("transaction_date")}
                                name="transaction_date"
                                value={this.props.values.transaction_date}
                                label={false}
                                showTime={false}
                                disabled={this.props.values.state > 520 || this.props.isLoading}
                                saveChanges={this.props.setFieldValue}
                            />
                            <div className="input-group-btn">
                                <Button
                                    color={this.props.values.transaction_date === this.props.initialValues.transaction_date ? "default" : "primary"}
                                    disabled={this.props.values.transaction_date === this.props.initialValues.transaction_date || this.props.isLoading}
                                    onClick={async () => {
                                        await this.props.processAction(async () => {
                                            return await postData({
                                                action: this.props.componentConfig.componentname + '.update',
                                                data: {
                                                    [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield],
                                                    transaction_date: this.props.values.transaction_date
                                                }
                                            });
                                        });
                                    }}>
                                    Mentés
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-6">
                        {
                            this.props.partnerType !== undefined
                            ?
                                <Select
                                    label="Partner"
                                    name={this.props.partnerType}
                                    component="partner"
                                    objectValue={true}
                                    labelKey="name"
                                    storeType="remote"
                                    disabled={true}
                                    value={this.props.values[this.props.partnerType]}
                                    {...this.props.getFieldProps(this.props.partnerType)}
                                    saveChanges={this.setFieldValue}
                                />
                            :
                                <Select
                                    label="Honnan"
                                    name="from"
                                    component="location"
                                    objectValue={true}
                                    labelKey="name"
                                    storeType="remote"
                                    disabled={true}
                                    value={this.props.values.origin}
                                    {...this.props.getFieldProps("origin")}
                                    saveChanges={this.setFieldValue}
                                />
                        }
                    </div>
                    <div className="col-sm-6">
                        <Select
                            label="Hova"
                            name="to"
                            component="location"
                            objectValue={true}
                            labelKey="name"
                            storeType="remote"
                            disabled={true}
                            value={this.props.values.destination}
                            {...this.props.getFieldProps("destination")}
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TextArea
                            name="comment"
                            value={this.props.values.comment || ''}
                            label="Megjegyzés"
                            disabled={true}
                            {...this.props.getFieldProps("comment")}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Items {...this.props} />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(stocktransferForm);
